module.exports = __webpack_public_path__ + "static/img/modification_hamburger@3x.f5f30bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/modification_hamburger@3x.png
// module id = eB2j
// module chunks = 1